import { action } from '@ember/object';
import Component from '@glimmer/component';
import type DeviceModel from 'garaje/models/device';

interface IpadRowComponentSignature {
  Args: {
    ipad: DeviceModel;
    isSelected: boolean;
    unselectIPad: (ipad: DeviceModel) => void;
    selectIPad: (ipad: DeviceModel) => void;
  };
}

export default class GlobalDevicesIpadsIpadRowComponent extends Component<IpadRowComponentSignature> {
  @action
  onIpadCheckboxClick(event: MouseEvent): void {
    if ((<HTMLInputElement>event.target).checked) {
      // add ipad when user select the ipad
      this.args.selectIPad(this.args.ipad);
    } else {
      // remove ipad from selected ipad
      this.args.unselectIPad(this.args.ipad);
    }
  }
}
